import React from "react";
import { Stage, Layer, Image, Transformer } from "react-konva";
import useImage from "use-image";
const URLImage = ({ image, isSelected, onSelect, onChange, onDelete }) => {
  const [img] = useImage(image.src);
  const shapeRef = React.useRef();
  const trRef = React.useRef();
  React.useEffect(() => {
    if (isSelected) {
      trRef.current.nodes([shapeRef.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);
  return (
    <React.Fragment>
      <Image
        image={img}
        x={image.x}
        y={image.y}
        offsetX={img ? img.width / 2 : 0}
        offsetY={img ? img.height / 2 : 0}
        onClick={onSelect}
        onTap={onSelect}
        draggable
        ref={shapeRef}
        onDragEnd={(e) => {
          onChange({
            ...image,
            x: e.target.x(),
            y: e.target.y(),
          });
        }}
        onTransformEnd={() => {
          const node = shapeRef.current;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();
          // Prevent the image from becoming too small
          if (scaleX < 0.5 || scaleY < 0.5) {
            onDelete();
          }
          onChange({
            ...image,
            x: node.x(),
            y: node.y(),
            rotation: node.rotation(),
            width: node.width() * scaleX,
            height: node.height() * scaleY,
          });
        }}
      />
      {isSelected && (
        <Transformer
          ref={trRef}
          boundBoxFunc={(oldBox, newBox) => {
            // limit resize
            if (newBox.width < 5 || newBox.height < 5) {
              return oldBox;
            }
            return newBox;
          }}
        />
      )}
    </React.Fragment>
  );
};
const Test2 = () => {
  const stageRef = React.useRef();
  const [images, setImages] = React.useState([]);
  const [selectedId, selectShape] = React.useState(null);
  const [dragUrl, setDragUrl] = React.useState(null); // Define dragUrl state
  const checkDeselect = (e) => {
    // deselect when clicked on empty area
    const clickedOnEmpty = e.target === e.target.getStage();
    if (clickedOnEmpty) {
      selectShape(null);
    }
  };
  const deleteShape = (id) => {
    const newImages = images.filter((image) => image.id !== id);
    setImages(newImages);
    selectShape(null);
  };
  return (
    <div>
      Try to drag an image into the canvas:
      <br />
      <img
        alt="lion"
        src="https://konvajs.org/assets/lion.png"
        draggable="true"
        onDragStart={(e) => {
          setDragUrl(e.target.src); // Update dragUrl when an image is dragged
        }}
      />
      <div
        onDrop={(e) => {
          e.preventDefault();
          stageRef.current.setPointersPositions(e);
          const pos = stageRef.current.getPointerPosition();
          const id = `image-${Date.now()}`;
          setImages((prevImages) => [
            ...prevImages,
            {
              id,
              x: pos.x,
              y: pos.y,
              src: dragUrl, // Use dragUrl here
              width: 100,
              height: 100,
              rotation: 0,
            },
          ]);
        }}
        onDragOver={(e) => e.preventDefault()}
      >
        <Stage
          width={window.innerWidth}
          height={window.innerHeight}
          style={{ border: "1px solid grey" }}
          ref={stageRef}
          onMouseDown={checkDeselect}
          onTouchStart={checkDeselect}
        >
          <Layer>
            {images.map((image) => (
              <URLImage
                key={image.id}
                image={image}
                isSelected={image.id === selectedId}
                onSelect={() => {
                  selectShape(image.id);
                }}
                onChange={(newAttrs) => {
                  const newImages = images.map((img) =>
                    img.id === image.id ? { ...img, ...newAttrs } : img
                  );
                  setImages(newImages);
                }}
                onDelete={() => {
                  deleteShape(image.id);
                }}
              />
            ))}
          </Layer>
        </Stage>
      </div>
    </div>
  );
};
export default Test2;